import React from 'react';
import { Box } from '@material-ui/core';
const BoxCenter = ({ className, children }) => {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={className}
    >
      {children}
    </Box>
  );
};

export default BoxCenter;
